"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
/**
 * Component class, use as base for your application components.
 */
var Accelerator_1 = __importDefault(require("./Accelerator"));
var Component = /** @class */ (function () {
    /**
     *
     * @param _ Deprecated
     * @param __ Deprecated
     */
    function Component(
    /** @deprecated */
    _, 
    /** @deprecated */
    __) {
        var _this = this;
        this.on = function () {
        };
        this.fire = function () {
        };
        if (this.constructor._instance) {
            return this.constructor._instance;
        }
        if (this.constructor.target === '') {
            throw new Error('You need to define a target.');
        }
        if (this.constructor._name === '') {
            throw new Error('You need to define a name.');
        }
        this.setElements();
        this.accelerator = new Accelerator_1.default();
        if ('IntersectionObserver' in window) {
            this._intersectionObserver = new IntersectionObserver(this.onIntersect.bind(this), this.constructor.intersectionConfig);
            this.each(function (_a) {
                var el = _a.el;
                return _this._intersectionObserver.observe(el);
            });
        }
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        window.onpagehide = this.destroy;
        window.onload = this.load;
        window.onunload = this.unload;
        this.on('load-component', this.componentMounted.bind(this));
        this.fire('component-loaded', { component: this, elements: this._el });
        this.constructor._instance = this;
    }
    Object.defineProperty(Component, "intersectionConfig", {
        get: function () {
            return {
                rootMargin: '0px',
                threshold: [0, 1],
            };
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.setElements = function () {
        this._el = Array.from(document.body.querySelectorAll(this.constructor.target));
    };
    Component.prototype.componentMounted = function () {
    };
    Component.prototype.onIntersect = function (_a, observer) {
        var entry = _a[0];
    };
    Component.prototype.forceReload = function () {
        this.setElements();
        this.fire('load-component');
        this.fire('component-loaded');
    };
    Component.prototype.load = function () {
    };
    Component.prototype.unload = function () {
    };
    Component.prototype.destroy = function () {
        var _a;
        if (this.all) {
            this.all.forEach(function (el) { return el.remove(); });
        }
        this.accelerator.removeAllSubscribers();
        (_a = this._intersectionObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    };
    Object.defineProperty(Component.prototype, "first", {
        get: function () {
            return this.all[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "all", {
        get: function () {
            return this._el;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Calls the passed function on all elements bound to this component.
     *
     * @param {CallableFunction} fun
     */
    Component.prototype.each = function (fun) {
        var _this = this;
        this.all.forEach(function (el) { return fun({ el: el, Component: _this }); });
    };
    /**
     * Calls the passed function on all function matching the where function.
     *
     * @param {CallableFunction} fun The function called on all fitting results
     * @param {CallableFunction} where The function filtering the data.
     */
    Component.prototype.some = function (fun, where) {
        var _this = this;
        this.all
            .filter(function (value, index, array) { return where({ value: value, index: index, array: array }); })
            .forEach(function (el) { return fun({ el: el, Component: _this }); });
    };
    /**
     * Debug info to help with development.
     */
    Component.prototype.dump = function () {
        console.log(this.constructor._name + " elements:", this.all);
    };
    /**
     * The target string to bind this Component to.
     */
    Component.target = '';
    /**
     * The component name. Used internally.
     */
    Component._name = '';
    return Component;
}());
exports.Component = Component;
exports.default = Component;
//# sourceMappingURL=Component.js.map